import './tabs.scss';
